function exportFun(url , data){ 
  console.log()
    window.open(`/yunyue-houtai/${url}?${objectToQueryString(removeEmptyStrings(data))}`)
}

function removeEmptyStrings(obj) {
    for (let key in obj) {
      if (obj[key] === '') {
        delete obj[key];
      }
    }
    return obj;
}

function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}

/**
 * 导出 
 **/
export {
    exportFun,
}


// WEBPACK FOOTER //
// ./src/utils/export.js